import { render, staticRenderFns } from "./TeamSelector.vue?vue&type=template&id=972c835e&scoped=true&lang=pug"
import script from "./TeamSelector.vue?vue&type=script&lang=js"
export * from "./TeamSelector.vue?vue&type=script&lang=js"
import style0 from "./TeamSelector.vue?vue&type=style&index=0&id=972c835e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972c835e",
  null
  
)

export default component.exports